import React, { Component } from "react";
import DateSelection from "./DateSelection/Date";
import Tooltip from "rc-tooltip";
import TipIcon from "material-ui/svg-icons/action/info-outline";
import Search from "material-ui/svg-icons/action/search";
import Button from "../framework/Button/Button";
import CampaignsTable from "./CampaignsTable";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import Checkbox from "material-ui/Checkbox";
import Dialog from "material-ui/Dialog";
import Page from "../framework/Page/Page";
import { FullRow, Row, Col } from "../framework/Grid";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import find from "lodash/find";
import forEach from "lodash/forEach";
import moment from "moment-timezone/moment-timezone";
const pdfConverter = require("jspdf");
const html2canvas = require("html2canvas");
import {
  initMomentTimezone,
  downLoadCSVFunc,
  pdfReportHeaderDataUri,
  addPdfFooter,
  getUrlParameterByName,
} from "../../utils/utility";

// css
import "./campaigns.css";
import isUndefined from "lodash/isUndefined";

class Campaigns extends Component {
  constructor(props) {
    super(props);
    initMomentTimezone();
    if (props.client_tz) {
      moment.tz.setDefault(props.client_tz);
    }
    const cid = getUrlParameterByName("cid");
    if (cid) {
      this.props.selectClient(parseInt(cid, 10));
    }
    this.state = {
      onCsvReportDownload: false,
      onPdfReportDownload: false,
      showDownloadDialog: false,
      disabledDlBtn: false,
      requestParams: {
        clientId: props.client_id,
        pageNumber: 1,
        pageSize: 7,
        sortColumn: "startDate",
        order: "desc",
        fromDate: props.campaignFilterStartDate
          ? props.campaignFilterStartDate
          : /*moment(moment().tz(props.client_tz)).startOf("month").format('YYYY-MM-DD')*/ null,
        toDate: props.campaignFilterEndDate
          ? props.campaignFilterEndDate
          : null,
        keyword: props.campaignFilterValue ? props.campaignFilterValue : "",
      },
    };
  }

  componentDidMount() {
    if (typeof this.props.client_id === "number")
      this.props.getTables(this.state.requestParams);
  }
  _addPdfHeader(pdf, client_name, bu_name) {
    pdf.setFillColor(127, 127, 127);
    pdf.rect(0, 15, 210, 10, "F");

    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(9);
    pdf.setFontType("bold");
    pdf.addImage(pdfReportHeaderDataUri(), "PNG", 10.5, 3, 60, 0);
    pdf.text(198, 8, moment().format("MMMM DD, YYYY"), null, null, "right");

    pdf.setTextColor(255, 255, 255);
    pdf.setFontType("bold");
    pdf.text(12, 21, "Client:");
    //const lenClientName = getTextSize(client_name.trim(), 'helvetica')
    pdf.setFontType("normal");
    pdf.text(26, 21, client_name ? client_name.trim() : "");
    //cm to inches
    let start = 90; //46 + lenClientName.width * 0.3937 + 0.4
    if (!isEmpty(bu_name)) {
      pdf.setFontType("bold");
      pdf.text(start, 21, "Business Unit:");
      start += 26.5;
      pdf.setFontType("normal");
      pdf.text(start, 21, bu_name ? bu_name.trim() : "");
    }
    pdf.setFillColor(255);
    start = 12;
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(10);
    //pdf.text(12, 30, 'Campaigns  >  ' + campaignDetail.name );
  }

  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.client_id === "number") {
      if (nextProps.client_id !== this.props.client_id) {
        const startDate = null; //moment(moment().tz(nextProps.client_tz)).startOf("month").format('YYYY-MM-DD');
        this.props.setCampaignFilterStartDate(startDate);
        this.props.setCampaignFilterEndDate(null);
        this.setState(
          {
            requestParams: {
              ...this.state.requestParams,
              clientId: nextProps.client_id,
              fromDate: startDate,
              toDate: null,
            },
          },
          () => {
            this.props.getTables(this.state.requestParams);
            this.props.history.push("/campaigns?cid=" + nextProps.client_id);
          },
        );
      }

      if (
        nextProps.csvData !== this.props.csvData &&
        !isUndefined(nextProps.csvData)
      ) {
        const { clients, client_info } = this.props;
        let client_name = client_info.name;
        let bu_name = "";
        if (client_info.parentClientId) {
          const parent_client = find(clients, c => {
            return c.id === client_info.parentClientId;
          });
          if (parent_client) {
            client_name = parent_client.name;
            bu_name = client_info.name;
          }
        }
        const { requestParams } = this.state;
        const { fromDate, toDate, keyword } = requestParams;
        if (this.state.onCsvReportDownload) {
          let title_line = "AudienceAnywhere Campaign List Report ,,,,,\r\n";
          let date_line =
            "Today's Date," + moment().format("MM/DD/YY") + ",,,,\r\n";
          let client_line = "Client," + client_name + ",,,,\r\n";
          let business_unit_line = isEmpty(bu_name)
            ? "\r\n"
            : "Business Unit," + bu_name + ",,,,\r\n";
          const split_line = ",,,,,\r\n";
          const from_date =
            "From Date," + moment(fromDate).format("MM/DD/YY") + ",,,,\r\n";
          const to_date = toDate
            ? "To Date," + moment(toDate).format("MM/DD/YY") + ",,,,\r\n"
            : "To Date,,,,,\r\n";
          const search_criteria = keyword
            ? `Search Criteria,${keyword},,,,\r\n`
            : `Search Criteria,,,,,`;
          const campaign_table_title_line = `Campaign Group Name,Campaign Group ID,Client Campaign ID,Campaign Group Status,Campaign Group Start Date,Campaign Group End Date\r\n`;

          let resultString =
            title_line +
            date_line +
            client_line +
            business_unit_line +
            split_line +
            from_date +
            to_date +
            search_criteria +
            split_line +
            campaign_table_title_line;
          map(nextProps.csvData.data, data => {
            const str = `${data.name},"${data.campaignId}", ${
              data.clientCampaignId ? data.clientCampaignId : ""
            },${data.status},${moment(data.startDate).format(
              "MM/DD/YYYY",
            )},${moment(data.endDate).format("MM/DD/YYYY")}\r\n`;
            resultString += str;
          });
          const csvFileName =
            bu_name === ""
              ? "Campaign_List_Report_" +
                client_name +
                "_" +
                moment().format("YYYYMMDD")
              : "Campaign_List_Report_" +
                bu_name +
                "_" +
                moment().format("YYYYMMDD");

          downLoadCSVFunc(resultString, csvFileName);
          setTimeout(
            function() {
              this.setState({ onCsvReportDownload: false });
            }.bind(this),
            2000,
          );
        }
        if (this.state.onPdfReportDownload) {
          const pdfFileName =
            bu_name === ""
              ? "Campaign_List_Report_" +
                client_name +
                "_" +
                moment().format("YYYYMMDD") +
                ".pdf"
              : "Campaign_List_Report_" +
                bu_name +
                "_" +
                moment().format("YYYYMMDD") +
                ".pdf";

          const pdf = new pdfConverter("p", "mm", "a4");
          pdf.setFont("Helvetica");
          pdf.setFontType("normal");
          pdf.setFontSize(9);
          const pageWidth = 186;

          const el_date_picker = document.getElementsByClassName(
            "date-picker",
          )[0];
          const el_tables = document.getElementsByClassName(
            "common-wrapper",
          )[0];
          const spreadTable = document.getElementsByClassName(
            "spread-table",
          )[0];

          let canvasDatePicker = null;
          let canvasTable = null;
          let isCanvasDatePickerReady = false;
          let isCanvasTableReady = false;
          const oriWidth = el_date_picker.offsetWidth;
          document.getElementsByClassName("spread-table")[0].style.maxHeight =
            "unset";
          document.getElementsByClassName("page")[0].style.display = "none";
          document.getElementsByClassName("icon")[0].style.display = "none";
          if (document.getElementsByClassName("campaigns-create").length > 0)
            document.getElementsByClassName(
              "campaigns-create",
            )[0].style.display = "none";
          document.getElementsByClassName("apply")[0].style.display = "none";
          document.getElementsByName("campaign_search")[0].placeholder = "";
          document.getElementsByClassName(
            "tooltip-container",
          )[0].style.display = "none";
          const datepickerIcons = document.getElementsByClassName(
            "react-datepicker__close-icon",
          );
          if (datepickerIcons.length > 0)
            datepickerIcons[0].style.display = "none";

          el_date_picker.style.width = "1024px";
          setTimeout(function() {
            html2canvas(el_date_picker, { logging: false }).then(function(
              canvas,
            ) {
              canvasDatePicker = canvas;
              isCanvasDatePickerReady = true;
              el_date_picker.style.width = oriWidth + "px";
            });
          }, 50);
          let linkColor = null;
          const campaignLinks = document.getElementsByClassName(
            "campaign-name-link",
          );
          setTimeout(function() {
            if (campaignLinks.length > 0) {
              linkColor = campaignLinks[0].style.color;
              forEach(campaignLinks, el => {
                el.style.color = "#000";
              });
            }
            html2canvas(el_tables, { logging: false }).then(function(canvas) {
              canvasTable = canvas;
              isCanvasTableReady = true;
              el_tables.style.width = oriWidth + "px";
              document.getElementsByClassName(
                "spread-table",
              )[0].style.maxHeight = "500px"; //document.getElementsByClassName("spread-table").style.maxHeight = '290px'
            });
          }, 50);

          let top = 32;
          const left = 12;
          let intervalId = setInterval(
            function() {
              if (
                isCanvasDatePickerReady === false ||
                isCanvasTableReady === false
              ) {
                console.log("PDF Generating...");
              } else {
                clearInterval(intervalId);
                setTimeout(
                  function() {
                    this._addPdfHeader(pdf, client_name, bu_name);

                    pdf.addImage(
                      canvasDatePicker.toDataURL(),
                      "PNG",
                      left,
                      top,
                      pageWidth,
                      0,
                    );
                    top +=
                      (canvasDatePicker.height * pageWidth) /
                        canvasDatePicker.width +
                      4;
                    pdf.addImage(
                      canvasTable.toDataURL(),
                      "PNG",
                      left,
                      top,
                      pageWidth,
                      0,
                    );
                    addPdfFooter(pdf);
                    document.getElementsByClassName("page")[0].style.display =
                      "block";
                    document.getElementsByClassName("icon")[0].style.display =
                      "block";
                    if (
                      document.getElementsByClassName("campaigns-create")
                        .length > 0
                    )
                      document.getElementsByClassName(
                        "campaigns-create",
                      )[0].style.display = "block";
                    document.getElementsByClassName("apply")[0].style.display =
                      "inline-block";
                    document.getElementsByName(
                      "campaign_search",
                    )[0].placeholder = "Search by Campaign Name or ID";
                    document.getElementsByClassName(
                      "tooltip-container",
                    )[0].style.display = "block";
                    if (datepickerIcons.length > 0)
                      datepickerIcons[0].style.display = "block";
                    if (campaignLinks.length > 0) {
                      forEach(campaignLinks, el => {
                        el.style.color = linkColor;
                      });
                    }
                    pdf.save(pdfFileName);
                    this.props.clearCampaignCsvData();
                    this.setState({ onPdfReportDownload: false });
                  }.bind(this),
                  100,
                );
              }
            }.bind(this),
            50,
          );
        }
      }
    }
  }

  handleStartDateChange(date) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        fromDate: date,
      },
    });
  }

  handleEndDateChange(date) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        toDate: date,
      },
    });
  }

  handleApplyBeClick() {
    this.props.setCampaignFilterValue(this.state.requestParams.keyword);
    this.props.setCampaignFilterStartDate(this.state.requestParams.fromDate);
    this.props.setCampaignFilterEndDate(this.state.requestParams.toDate);
    this.props.getTables(this.state.requestParams);
  }

  downloadCsvReport() {
    this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
  }

  downloadPdfReport() {
    this.setState({ onPdfReportDownload: true, showDownloadDialog: false });
  }

  handleBtnClick(e) {
    e.preventDefault();
    this.setState({ showDownloadDialog: true });
  }

  handleDownload(e) {
    e.preventDefault();
    this.props.clearCampaignCsvData();
    setTimeout(
      function() {
        this.props.getCampaignCsvData({
          clientId: this.state.requestParams.clientId,
          pageNumber: 1,
          pageSize: 99999,
          sortColumn: this.state.requestParams.sortColumn,
          order: this.state.requestParams.order,
          fromDate: this.state.requestParams.fromDate,
          toDate: this.state.requestParams.toDate,
          keyword: this.state.requestParams.keyword,
        });
      }.bind(this),
      2000,
    );

    if (this.refs.cbPDF.state.switched) {
      this.downloadPdfReport();
    }

    if (this.refs.cbCSV.state.switched) {
      this.downloadCsvReport();
    }
  }

  cbPDFChange(e, isInputChecked) {
    const result = !this.refs.cbCSV.state.switched && !isInputChecked;
    this.setState({ disabledDlBtn: result });
  }

  cbCSVChange(e, isInputChecked) {
    const result = !this.refs.cbPDF.state.switched && !isInputChecked;
    this.setState({ disabledDlBtn: result });
  }

  onSearchChange(e) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        keyword: e.target.value.trim(),
      },
    });
  }

  handleSearch(e) {
    e.preventDefault();
    this.props.setCampaignFilterValue(this.state.requestParams.keyword);
    this.props.setCampaignFilterStartDate(this.state.requestParams.fromDate);
    this.props.setCampaignFilterEndDate(this.state.requestParams.toDate);
    this.props.getTables(this.state.requestParams);
  }

  searchWithSort(sortField, sortDesc) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        sortColumn: sortField,
        order: sortDesc ? "desc" : "asc",
      },
    });

    this.props.getTables({
      ...this.state.requestParams,
      sortColumn: sortField,
      order: sortDesc ? "desc" : "asc",
    });
  }

  handleCreateCampaign() {
    this.props.clearCampaignDetail();
    this.props.history.push("/campaigns/create");
  }

  nextBeClick(page) {
    this.pageAbleFunc(page);
  }
  previousBeClick(page) {
    this.pageAbleFunc(page);
  }
  goToPage(page) {
    this.pageAbleFunc(page);
  }
  pageAbleFunc(val) {
    this.setState(
      {
        requestParams: {
          ...this.state.requestParams,
          pageNumber: val,
          pageSize: 7,
        },
      },
      () => {
        this.props.getTables(this.state.requestParams);
      },
    );
  }
  onClickEditCampaign(e, id) {
    e.preventDefault();
    this.props.getCampaignById(id, this.props.client_id);
  }
  render() {
    const {
      campaignDataOnLoading,
      tables,
      campaignDataLoadErrorMessage,
      roleId,
    } = this.props;
    return (
      <MuiThemeProvider>
        <div className="campaigns subscription-info">
          <div className="campaigns-btn clearfix">
            <div className="wrapper">
              <Button
                title="Download Report"
                handleClick={e => this.handleBtnClick(e)}
              />
            </div>
          </div>
          <div className="date-picker">
            <DateSelection
              key="campaign-date-filter"
              defaultStartDate={this.props.campaignFilterStartDate}
              defaultEndDate={this.props.campaignFilterEndDate}
              startDateChange={date => this.handleStartDateChange(date)}
              endDateChange={date => this.handleEndDateChange(date)}
              handleApplyBeClick={() => this.handleApplyBeClick()}
              timezone={this.props.clients_tz}
            />
            {((campaignDataOnLoading === false &&
              (isEmpty(tables) || isEmpty(tables.data))) ||
              campaignDataLoadErrorMessage) && (
              <FullRow
                className="no-margin no-padding-top pl-10"
                style={{ background: "#FFFFFF" }}
              >
                <span style={{ color: "#FF0000" }}>
                  <i className="icon-warning2 pr-10" />
                  {campaignDataLoadErrorMessage
                    ? campaignDataLoadErrorMessage
                    : "No campaigns found within date range selected"}
                </span>
              </FullRow>
            )}
          </div>
          <div className="common-wrapper mt-20">
            <h2 style={{ position: "absolute" }}>Campaigns</h2>
            <div style={{ marginLeft: "150px", height: "24px" }}>
              {this.props.campaignDataOnLoading && (
                <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
              )}
              <div className="pull-right tooltip-container">
                <Tooltip
                  placement="right"
                  overlayClassName="campaign-report-legend"
                  overlayStyle={{ width: "345px" }}
                  overlay={
                    <div className="legend-overlay-container">
                      <div className="border-bottom pb-5 mb-5">
                        <strong>Campaign Group Status Definitions</strong>
                      </div>
                      <strong>Draft - </strong>Campaign Group has been created
                      but no
                      <br />
                      channel campaigns have been associated to the group
                      <br />
                      <br />
                      <strong>Scheduled - </strong> Campaigns are associated to
                      the
                      <br />
                      campaign group with a start date in the future
                      <br />
                      <br />
                      <strong>Active - </strong> Campaign(s) are in process
                      <br />
                      <br />
                      <strong>Completed - </strong> Campaign end date(s) have{" "}
                      <br />
                      been reached
                    </div>
                  }
                  arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                >
                  <TipIcon
                    style={{
                      color: "black",
                      width: "24px",
                      height: "24px",
                      marginTop: "0px",
                      marginLeft: "0px",
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              </div>
            </div>

            <div className="search-wrapper clearfix">
              <span className="search-tit">Search</span>
              <div className="search-bar">
                {/*
                <Typeahead
                  options={[]}
                  multiple={false}
                  placeholder="Search by Campaign Name or ID"
                  onChange={(selectedItem) => this.handleCampaignChange(selectedItem)}
                />*/}
                <input
                  placeholder="Search by Campaign Name or ID"
                  name="campaign_search"
                  style={{ width: "100%", lineHeight: "25px", border: "none" }}
                  defaultValue={this.props.campaignFilterValue}
                  onChange={this.onSearchChange.bind(this)}
                />
              </div>
              <div className="icon">
                <button onClick={this.handleSearch.bind(this)}>
                  <Search
                    style={{
                      color: "white",
                      marginLeft: "-4px",
                      marginTop: "2px",
                    }}
                  />
                </button>
              </div>
              {(roleId === 1 || roleId === 5) && (
                <div className="campaigns-create">
                  <Button
                    title="Create Campaign Group"
                    handleClick={() => this.handleCreateCampaign()}
                  />
                </div>
              )}
            </div>
            {!campaignDataOnLoading &&
              (isEmpty(tables) || isEmpty(tables.data)) &&
              !isEmpty(this.state.requestParams.keyword) && (
                <FullRow
                  className="no-margin no-padding-left no-padding-bottom"
                  style={{ background: "#FFFFFF" }}
                >
                  <span style={{ color: "#FF0000", marginLeft: "-10px" }}>
                    <i className="icon-warning2 pr-10" />
                    No search results found{" "}
                  </span>
                </FullRow>
              )}
            <div className="campaigns-table">
              <CampaignsTable
                tableHeaderArr={[
                  { label: "Campaign Group \nName", value: 0 },
                  { label: "Campaign Group \nID", value: 1 },
                  { label: "Client Campaign \nID", value: 2 },
                  { label: "Campaign Group \nStatus", value: 3 },
                  { label: "Campaign Group \nStart Date", value: 4 },
                  { label: "Campaign Group \nEnd Date", value: 5 },
                  { label: "", value: 6 },
                ]}
                bodyDataArr={
                  !isEmpty(this.props.csvData) && this.state.onPdfReportDownload
                    ? this.props.csvData.data
                    : this.props.tables
                    ? this.props.tables.data
                    : []
                }
                tableHeaderWidthStyle={[
                  "20%",
                  "16%",
                  "15%",
                  "16%",
                  "15%",
                  "15%",
                ]}
                handleClickEditCampaign={this.onClickEditCampaign.bind(this)}
                canEdit={
                  (this.props.roleId === 1 || this.props.roleId === 5) &&
                  isEmpty(this.props.csvData)
                }
                handleSearch={this.searchWithSort.bind(this)}
              />
              <Page
                nextBeClick={page => this.nextBeClick(page)}
                pageNumber={
                  !isEmpty(this.props.csvData)
                    ? this.props.csvData.pageNumber
                    : this.props.tables && this.props.tables.pageNumber
                }
                pageCount={
                  !isEmpty(this.props.csvData)
                    ? this.props.csvData.pageCount
                    : this.props.tables && this.props.tables.pageCount
                }
                pageSize={
                  !isEmpty(this.props.csvData)
                    ? this.props.csvData.pageSize
                    : this.props.tables && this.props.tables.pageSize
                }
                nextGroupBeClick={page => this.nextGroupBeClick(page)}
                previousGroupBeClick={page => this.previousGroupBeClick(page)}
                previousBeClick={page => this.previousBeClick(page)}
                pageBeClick={page => this.pageBeClick(page)}
                total={
                  !isEmpty(this.props.csvData)
                    ? this.props.csvData.total
                    : this.props.tables && this.props.tables.total
                }
                hasNext={
                  !isEmpty(this.props.csvData)
                    ? this.props.csvData.hasNext
                    : this.props.tables && this.props.tables.hasNext
                }
                hasPrevious={
                  !isEmpty(this.props.csvDta)
                    ? this.props.csvData.hasPrevious
                    : this.props.tables && this.props.tables.hasPrevious
                }
                pagePlus={true}
                selectRows={(page, row) => this.selectRows(page, row)}
                goToPage={page => this.goToPage(page)}
              />
            </div>
          </div>
          <Dialog
            open={this.state.onCsvReportDownload}
            style={{ top: "-1.8em" }}
            modal={true}
            contentStyle={{ width: "500px" }}
            overlayStyle={{ opacity: 0.9, backgroundColor: "#666666" }}
          >
            <Row className="mt-20">
              <Col
                offsetXs="1"
                offsetSm="1"
                offsetMd="1"
                offsetLg="1"
                xs="7"
                sm="7"
                md="7"
                lg="7"
                className="text-right"
              >
                <div>{"Downloading, please wait..."}</div>
              </Col>
              <Col xs="1" sm="1" md="1" lg="1">
                <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
              </Col>
            </Row>
          </Dialog>
          <Dialog
            open={this.state.onPdfReportDownload}
            style={{ top: "-1.8em" }}
            modal={true}
            contentStyle={{ width: "500px" }}
            overlayStyle={{ opacity: 0.9, backgroundColor: "#666666" }}
          >
            <Row className="mt-20">
              <Col
                offsetXs="1"
                offsetSm="1"
                offsetMd="1"
                offsetLg="1"
                xs="7"
                sm="7"
                md="7"
                lg="7"
                className="text-right"
              >
                <div>{"Downloading, please wait..."}</div>
              </Col>
              <Col xs="1" sm="1" md="1" lg="1">
                <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
              </Col>
            </Row>
          </Dialog>
          <Dialog
            open={this.state.showDownloadDialog}
            style={{ top: "-1.8em" }}
            modal={true}
            contentStyle={{ width: "440px" }}
          >
            <FullRow
              className="no-margin-top no-padding text-center"
              style={{ fontSize: "16px", color: "#000" }}
            >
              <strong>
                Choose the type of file you would like to download
              </strong>
            </FullRow>
            <FullRow
              className="no-padding-top no-padding-right no-padding-bottom no-margin-bottom"
              style={{ paddingLeft: "150px" }}
            >
              <Checkbox
                iconStyle={{ fill: "#47A1AB", marginRight: "10px" }}
                label={"PDF File"}
                labelStyle={{ fontSize: "13px" }}
                defaultChecked={false}
                ref="cbPDF"
                onCheck={(e, isInputChecked) =>
                  this.cbPDFChange(e, isInputChecked)
                }
              />
            </FullRow>
            <FullRow
              className="no-padding-top no-padding-right no-padding-bottom"
              style={{ paddingLeft: "150px" }}
            >
              <Checkbox
                iconStyle={{ fill: "#47A1AB", marginRight: "10px" }}
                label={"CSV File"}
                labelStyle={{ fontSize: "13px" }}
                defaultChecked={true}
                ref="cbCSV"
                onCheck={(e, isInputChecked) =>
                  this.cbCSVChange(e, isInputChecked)
                }
              />
            </FullRow>
            <FullRow className="no-padding no-margin-bottom mt-20 text-center">
              <button
                type="button"
                onClick={() => this.setState({ showDownloadDialog: false })}
                className="btn btn-default btn-aa-info mr-20"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={this.handleDownload.bind(this)}
                disabled={this.state.disabledDlBtn}
                className="btn btn-default btn-aa-default"
              >
                Download File
              </button>
            </FullRow>
          </Dialog>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default Campaigns;



// WEBPACK FOOTER //
// ./src/components/Campaigns/Index.jsx